import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const RequireAdmin: React.FC = () => {
  const { token } = useAuth();
  const loc = useLocation();
  if (!token) {
    return <Navigate to="/admin/login" replace state={{ from: loc }} />;
  }
  return <Outlet />;
};
